import React from 'react'

const StatusCircle = ({ status, isTitle, onModal }) => {

  let statusColor;

  switch (status) {
    case 0:
      statusColor = "#58595B"
      break;
    case 1:
      statusColor = "#80D15D"
      break;
    case "online":
      statusColor = "#80D15D"
      break;
    case 2:
      statusColor = "#E55555"
      break;
    default:
      statusColor = "#58595B"
      break;
  }

  //style for status
  const statusDotStyle = {
    // Channel fee
    circleDot: {
      width: '11px',
      height: '11px',
      borderRadius: '50%',
      backgroundColor: statusColor,
      border: '1px solid #FFFFFF',
      bottom: isTitle ? '13px' : '0px',
      left: isTitle ? '45px' : '30px',
      position: 'absolute',
      zIndex: '99'
    },
    modalCircleDot:{
      width: '20px',
      height: '20px',
      borderRadius: '50%',
      backgroundColor: statusColor,
      border: '1px solid #FFFFFF',
      bottom: isTitle ? '13px' : '0px',
      right: '5px',
      position: 'absolute',
      zIndex: '99'
    }
  };

  return (
    <div style={onModal? statusDotStyle.modalCircleDot : statusDotStyle.circleDot} />
  )
}

export default StatusCircle;
